import { FC } from 'react';

import {
  useProcessedBannerStore,
  useProcessedProblems,
} from '../../../studentApp/hooks';
import { problemStore } from '../../../studentApp/stores';
import { BOX_SHADOW_REGION } from '../../constants';
import { squareGroupsStyle } from '../util/constants';

import { LabelAndSquares } from './labelAndSquares';
import { RegionLabel } from './regionLabel';

export const ExamRegion: FC = () => {
  const problemNumber = problemStore(state => state.currentExamProblemNumber);
  const examProblems = useProcessedProblems().examProblems;
  const themeColor = useProcessedBannerStore().themeColor;

  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'left',
          alignItems: 'center',
        }}
      >
        <RegionLabel text={'Exam Questions'} />
      </div>

      <div
        className="scrollable"
        style={{
          ...squareGroupsStyle,
          boxShadow: `${BOX_SHADOW_REGION} ${themeColor}`,
        }}
      >
        <LabelAndSquares
          text={problemNumber ? '#' + problemNumber : ''}
          problems={examProblems}
        />
      </div>
    </>
  );
};
